import React from 'react';

import styles from './AccessToCommunity.module.css';

export default ({
  internalRecord,
  setInternalRecord
  // activePopup
}) => (
    <div className={styles.content}>
      <div className={styles.row}>
        <div className={styles.label}>Survey questions</div>
        <div className={styles.inputContainer}>
          <input
            className={styles.valueInput}
            placeholder="0"
            value={
              internalRecord.permissions.questionsPerSurveyIncludedInLicence ||
              ''
            }
            onChange={e => {
              if (e.target.value && e.target.value !== '') {
                const newAllocatedValue = parseInt(e.target.value, 10);

                setInternalRecord({
                  ...internalRecord,
                  permissions: {
                    ...internalRecord.permissions,
                    questionsPerSurveyIncludedInLicence: newAllocatedValue
                  }
                });
              }
            }}
            onKeyDown={evt =>
              evt.key === 'ArrowDown' ||
              evt.key === 'ArrowUp' ||
              evt.key === 'e' ||
              evt.key === 'E' ||
              evt.key === '-'
                ? evt.preventDefault()
                : null
            }
            onWheel={e => e.target.blur()}
            maxLength="6"
            type="number"
            spellCheck
          />
        </div>
      </div>
    </div>
  );
